import {defineStore} from 'pinia';
import {ModuleContext} from './moduleConst';
import accountApi from '@/apis/auth/accountApi';
import moment from 'moment';
import dvcUserApi from '@/apis/dvc/dvcUserApi';

const state = {
  context: {token: '', sessionId: '', PandaSessionId: ''},
  postedDate: moment(new Date()).startOf('day').toDate(),

  /**
   * Thông tin phân quyền của user
   */
  permission: null,

  /**
   * Trạng thái Collapse của left menu
   * HQMINH 09.06.2023
   */
  leftMenuState: false,

  /**
   * @description Tham số báo cáo (Lấy từ Tham số báo cáo)
   * @author nvthinh 25.07.2023
   */
  reportParam: {},
};
const actions = {
  // Cập nhật token của context (nvthinh 17.04.2024)
  async updateToken(token, expiredToken, refreshToken) {
    if (token) {
      this.context.Token = token;
    }

    if (typeof expiredToken === 'string') {
      this.context.ExpiredToken = expiredToken;
    }

    if (refreshToken) {
      this.context.RefreshToken = refreshToken;
    }
  },

  async getToken(payload) {
    const context = await accountApi.getToken(payload);
    Object.assign(this.context, context);
    // Lưu permission vào state
    if (context.Permission) {
      this.permission = context.Permission;
    }
    return context;
  },

  /**
   * check tồn tại db trước, nếu tồn tại thì mới get token
   * @param {*} payload
   * nvxuan 23.11.2023
   * @returns object = {ExistsDb, Token}
   */
  async getTokenV2(payload) {
    const res = await accountApi.getTokenV2(payload);

    if (res.ExistsDb) {
      Object.assign(this.context, res.Token);
      // Lưu permission vào state
      if (res.Token.Permission) {
        this.permission = res.Token.Permission;
      }
    }

    return res;
  },

  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   */
  async loginCallback(payload) {
    const context = await accountApi.loginCallback(payload);
    this.context = context;
    // Lưu permission vào state
    if (context.Permission) {
      this.permission = context.Permission;
    }
    return context;
  },

  /**
   * Get link từ MisaID
   */
  async getMisaIdLink(payload) {
    try {
      return await accountApi.getMisaIdLink(payload);
    } catch (ex) {
      return null;
    }
  },

  /**
   * Lấy lịch sử thỏa thuận hoặc chính sách
   * @param {*} payload
   * pvdat1 28/02/2024
   */
  async getHistoryAgreement(payload) {
    try {
      return await accountApi.getHistoryAgreement(payload);
    } catch (error) {
      return null;
    }
  },

  /**
   * Cập nhật postedDate
   * @param {*} state
   * @param {*} payload
   * tvtoan 17/05/2023
   */
  updatePostedDate(payload) {
    if (payload && payload.PostedDate) {
      this.context.PostedDate = payload.PostedDate;
      this.$state.postedDate = payload.PostedDate;
    }
  },

  /**
   * Đăng xuất
   */
  async logout() {
    const request = {
      url: [accountApi.getAPIUrl(), 'logout'].join('/'),
    };

    try {
      const res = await accountApi.getAsync(request);
    } catch (ex) {
      // khi bị exception System.InvalidOperationException: StatusCode cannot be set because the response has already started.
      // thì cứ redirect đến login
    }

    // Ngắt kết nối DVC nếu đang kết nối
    try {
      const dvcUser = JSON.parse(localStorage.getItem('DVCUser') || '{}');
      if (dvcUser?.token_key) {
        await dvcUserApi.logoutDVC(dvcUser.token_key);
      }
    } catch (ex) {
    } finally {
      localStorage.removeItem('DVCUser');
      localStorage.removeItem('DVCTreasuryCode');
      localStorage.removeItem('DVCTreasuryName');
      localStorage.removeItem('DVCBudgetCode');
      localStorage.removeItem('DVCRole');
      localStorage.removeItem('DVCToken');
      localStorage.removeItem('DVCApprover');
      localStorage.removeItem('DVCTokenExpire');
      localStorage.removeItem('DVCTransactionAccounts');
    }

    // Loại bỏ token, cache, permission
    this.context = null;
    this.permission = null;
    // Xóa tất cả sessionStorage
    sessionStorage.clear();
    localStorage.removeItem('context');
    const url = window._misaId.getUrl('logoutUrl');
    location.href = url;
  },

  /**
   * Xử lý đăng nhập thông tin tài khoản và set token
   */
  async login() {
    // const context = await accountApi.login();
    const context =
      JSON.parse(`{"context":{"token":"","sessionId":"","PandaSessionId":"b177d5f1-5095-44c8-a183-34b1c511c82d","BambooSessionId":"f6ff2efd-1bf6-41b2-ab2d-9aac71099b2b","Token":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJjNmVhNTlkMy0wZTgxLTExZWUtYmU4NS0wMDUwNTZiM2RmMjMiLCJkaWQiOiIzZTkwMTIyYS01OTZlLTRmNTItYTljNi04YTUwOWZhYWI3MDkiLCJzaWQiOiIyZGQxY2ExNjQwNTM0OTA3YTk3OGNhNzUzYmQ4NzE4MCIsImJ1YyI6IjExMTExOTk5IiwibmJmIjoxNzE1MjI1NzY3LCJleHAiOjE3MTUyNDAxNjcsImlhdCI6MTcxNTIyNTc2NywiaXNzIjoiTUlTQUpTQyJ9.6aqDikqWDZFFpcnKASJdT8d6h2nt2geHKVKiYHIUD44","RefreshToken":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJjNmVhNTlkMy0wZTgxLTExZWUtYmU4NS0wMDUwNTZiM2RmMjMiLCJkaWQiOiIzZTkwMTIyYS01OTZlLTRmNTItYTljNi04YTUwOWZhYWI3MDkiLCJzaWQiOiIyZGQxY2ExNjQwNTM0OTA3YTk3OGNhNzUzYmQ4NzE4MCIsImJ1YyI6IjExMTExOTk5IiwicmZkIjoiNDMyMDAiLCJ1bmEiOiJidmJhb0BnbWFpbC5jb20iLCJ0aWQiOiIzOGQ1MzQ3Ni0wZmYwLTExZWUtYmU4NS0wMDUwNTZiM2RmMjMiLCJuYmYiOjE3MTUyMjU3NjcsImV4cCI6MTcxNTI2ODk2NywiaWF0IjoxNzE1MjI1NzY3LCJpc3MiOiJNSVNBSlNDIn0.0Sj4sVQzOrLFiI3BKdiPrjIXJR3QCF5oHPgxCX3A-ag","TokenTimeout":43200,"ExpiredToken":"2024-05-09T07:36:07.000Z","Permission":null,"Context":{"TenantId":"074c3fdb-37e7-11ee-be85-005056b3df23","TenantName":"UBDN Xã Văn Minh","BudgetCode":"11111999","DatabaseName":"Dữ liệu năm bvbao Test báo cáo","DatabaseId":"3e90122a-596e-4f52-a9c6-8a509faab709","NewDatabase":false,"LoginDate":"2024-05-09T03:36:07.000Z","UserId":"00000000-0000-0000-0000-000000000000","Email":"bvbao@gmail.com","Avatar":"http://testmisaidapi.misa.local/api/images?userId=2ef9f07b-0948-40f2-bece-1b6c7f015dfa&width=88&height=88","SiteMISAID":"https://testmisaid.misa.local","WarningExpied":{"ShowWarningExpiedType":-1,"DayNearExpired":0,"NumberOverExpired":0,"ExpiredDate":"0000-12-31T16:53:30.000Z","OrderDescriptor":"","RestrictVoucherAction":false,"ShowWarningExpiredDateTop":false,"ShowWarningExpiredDate":false},"StartDateLicense":"0000-12-31T16:53:30.000Z","ExpiredDateLicense":"0000-12-31T16:53:30.000Z","OverExpiredDate":false,"SessionId":"2dd1ca1640534907a978ca753bd87180","Mobile":"0911666789","CheckLicense":false,"FirstLogin":false,"isManagermentSource":false,"isAccountManager":false,"HasRole":false,"CreatedAccountingDataDate":"2023-08-03T10:00:56.000Z","AccountingDate":"2022-12-31T17:00:00.000Z","LastAccountingDate":"2022-03-18T17:00:00.000Z","IsConvert":false,"IsConvertDesktop":true,"MisaIdAccessToken":"eyJhbGciOiJSUzI1NiIsImtpZCI6IkQzQzMwQzhERDg2RTI4NDhCNkUwRDNGMEUyNjY3QzVDQzI0Mzg3RDQiLCJ0eXAiOiJKV1QiLCJ4NXQiOiIwOE1NamRodUtFaTI0TlB3NG1aOFhNSkRoOVEifQ.eyJuYmYiOjE3MTUyMjU3NjIsImV4cCI6MTcxNTIyOTM2MiwiaXNzIjoiaHR0cHM6Ly90ZXN0bWlzYWlkLm1pc2EubG9jYWwiLCJhdWQiOiJodHRwczovL3Rlc3RtaXNhaWQubWlzYS5sb2NhbC9yZXNvdXJjZXMiLCJjbGllbnRfaWQiOiJiNzkzMDYzNC04M2Q3LTRiY2ItYWIyYS05NThhYTkxZmYyZDIiLCJzdWIiOiIyZWY5ZjA3Yi0wOTQ4LTQwZjItYmVjZS0xYjZjN2YwMTVkZmEiLCJhdXRoX3RpbWUiOjE3MTUyMjU3NjIsImlkcCI6ImxvY2FsIiwibWlzYWlkIjoiMmVmOWYwN2ItMDk0OC00MGYyLWJlY2UtMWI2YzdmMDE1ZGZhIiwidXNlcm5hbWUiOiJidmJhb0BnbWFpbC5jb20iLCJlbWFpbCI6ImJ2YmFvQGdtYWlsLmNvbSIsInBob25lX251bWJlciI6IjA5MTE2NjY3ODkiLCJjdWx0dXJlIjoidmktVk4iLCJmaXJzdF9uYW1lIjoiQuG6o28iLCJsYXN0X25hbWUiOiJCw7lpIFbEg24iLCJzY29wZSI6WyJvcGVuaWQiXSwiYW1yIjpbInB3ZCJdfQ.uKGAtSZZXZvbCLpk4XX2UfetiGPOTcaizgUSyj2CFljNuj3U7TZky3H4z61IDC1J197zVxvmlaY9yCzrDeEhy3_FecARb3SbhD1EtSMfrk_siEB2j3W-0Jirz0x5F0HPab5nNMMUwi5dHXM6i6s8zvjxhhTo05h-XIUR1gvZn0XjmiFKCyxamkdqTuW9LwfDQXWCfiwR-c44Pes-8ZnVoCzsI5k9Xw8rRHhKp3P8TsUSBlsbwML8eETulU1Q0h1ugosF8YqnwdYvya_SsA8Z-W0p5OhOH-wkXD71nQ_BYZ-7qSuMIeVa_3hw7xh2hCz5LMsdFFzL9xBErN291AKTZg","AVAConnectInfo":"{\\"token\\":\\"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGFpZCI6IjNhMTFkZDQ4LTNiMTgtOTczOC0zOGJhLWZlOWZiOTc0MzNkYSIsImFwdWlkIjoiM2ExMTJhMmEtYTJhNi1mOTM0LTE1YjYtOWNlYjExOTZiMDMxIiwiYXBzaWQiOiJlZTA5NmEwNC1lNzRhLTQzZDctYmM3Ni03MmZjMDZjNDZiYzMiLCJhcGZzIjoiY2hhdGJvdCxjb21tYW5kLHJlcG9ydCxnZW5lcmF0aXZlLHN0YXRpc3RpYyIsImFwZ2ZzIjoidm9pY2VfdG9fdGV4dCxjb250ZW50X2NyZWF0aW9uLGV4dHJhY3Rpb24sdHJhbnNsYXRpb24saW1hZ2VfY3JlYXRpb24sc3VtbWFyeSxzcGVsbF9jb3JyZWN0aW9uIiwiYWlhaWQiOiIzYTExZGQ0OC0zYjE4LTk3MzgtMzhiYS1mZTlmYjk3NDMzZGEiLCJhaWFjb2RlIjoiQVZBQmFtIiwiYWllbnYiOiJ0ZXN0IiwiYWl1aWQiOiIzYTExMmEyYWEyYTZmOTM0MTViNjljZWIxMTk2YjAzMSIsIm5iZiI6MTcxNTIyNTU2OCwiZXhwIjoxNzE1MzExOTY4LCJpYXQiOjE3MTUyMjU1NjgsImlzcyI6Ik1JU0FKU0MifQ.dCK2G86-tNTgsZ56EBLN72mrntprsZE_3AjigXfZQD4\\",\\"tokenExpiredSeconds\\":86400,\\"apiUrl\\":\\"http://ava.misa.local/ava-bot-api\\",\\"baseUrl\\":\\"http://avacdn.misa.local/ava-bot-ui\\",\\"sessionId\\":\\"ee096a04-e74a-43d7-bc76-72fc06c46bc3\\",\\"logDelayChartRender\\":5000,\\"avaConfig\\":[{\\"FeatureCode\\":\\"chatbot\\",\\"FeatureName\\":\\"Hỗ trợ sử dụng phần mềm\\",\\"Description\\":\\"Hướng dẫn sử dụng các tính năng của phần mềm\\"},{\\"FeatureCode\\":\\"command\\",\\"FeatureName\\":\\"Thực hiện nhanh chức năng\\",\\"Description\\":\\"Lập tờ khai, lập hóa đơn, lập báo cáo, ...\\"},{\\"FeatureCode\\":\\"report\\",\\"FeatureName\\":\\"Xem nhanh số liệu báo cáo\\",\\"Description\\":\\"Cung cấp các số liệu thống kê, báo cáo nhanh\\"},{\\"FeatureCode\\":\\"generative\\",\\"FeatureName\\":\\"Tạo nội dung\\",\\"Description\\":\\"Tạo nội dung dựa trên AI tạo sinh\\"},{\\"FeatureCode\\":\\"voice_to_text\\",\\"FeatureName\\":\\"Chuyển hóa giọng nói thành văn bản\\",\\"Description\\":\\"Từ nay AVA có thể nghe bạn kể chuyện và viết xuống câu chuyện đó giúp cho bạn.\\"},{\\"FeatureCode\\":\\"content_creation\\",\\"FeatureName\\":\\"Tạo nội dung\\",\\"Description\\":\\"Khả năng tạo ra văn bản mới dựa trên thông tin đầu vào đã có theo nhiều phong cách hơn. Điều này có thể giúp cập nhật hoặc làm mới nội dung\\"},{\\"FeatureCode\\":\\"extraction\\",\\"FeatureName\\":\\"Trích xuất\\",\\"Description\\":\\"AVA cho phép bạn dễ dàng rút trích hình ảnh, tài liệu từ các tập tin đã lưu trữ, giúp tiết kiệm thời gian và nâng cao hiệu suất làm việc.\\"},{\\"FeatureCode\\":\\"translation\\",\\"FeatureName\\":\\"Dịch\\",\\"Description\\":\\"Phá mọi rào cản ngôn ngữ bằng khả năng chuyển đổi văn bản từ ngôn ngữ này sang ngôn ngữ khác\\"},{\\"FeatureCode\\":\\"image_creation\\",\\"FeatureName\\":\\"Tạo ảnh\\",\\"Description\\":\\"AVA giúp tạo ra những hình ảnh độc đáo và sáng tạo bằng cách tự động kết hợp, biến đổi các yếu tố khác nhau, mang lại trải nghiệm độc đáo và tiện lợi cho người dùng.\\"},{\\"FeatureCode\\":\\"summary\\",\\"FeatureName\\":\\"Tóm tắt nội dung\\",\\"Description\\":\\"Khả năng tạo ra một bản tóm tắt ngắn gọn của một đoạn văn bản hoặc nội dung dựa trên thông tin đã cho. Nó như một bản rút gọn giúp hiểu nhanh chóng về nội dung chính mà không cần đọc toàn bộ văn bản gốc.\\"},{\\"FeatureCode\\":\\"spell_correction\\",\\"FeatureName\\":\\"Kiểm tra chính tả\\",\\"Description\\":\\"Khả năng phát hiện và sửa những sai sót về chính tả trong văn bản\\"}]}"},"SecurityMisaId":{"WarningSecurity":false,"WarningSecurityPassword":false,"WarningSecurity2FA":false},"NpsServeyLink":null,"NpsReasonFalse":"","user":{"user_id":"c6ea59d3-0e81-11ee-be85-005056b3df23","misa_id":"2ef9f07b-0948-40f2-bece-1b6c7f015dfa","full_name":"Bùi Văn Bảo","user_name":"bvbao@gmail.com","email":"bvbao@gmail.com"},"loginType":1,"PostedDate":"2022-05-14T00:53:45.026Z"},"postedDate":"2022-05-14T00:53:45.026Z","leftMenuState":true,"reportParam":{}}`);
    this.context = context.context;

    return context.context;
  },

  /**
   * cập nhật client_id vào context
   * @param {*} state
   * @param {*} clientid
   */
  updateSocketClientId(clientid) {
    this.context.PandaSessionId = clientid;
  },

  /**
   * Cập nhật lại trạng thái Collapse menu
   * HQMINH 09.06.2023
   */
  updateLeftMenu(payload) {
    this.leftMenuState = payload;
  },

  /**
   * @description Cập nhật lại tham số lập báo cáo
   * @author nvthinh 25.07.2023
   */
  updateReportParam(param) {
    this.reportParam = Object.assign(param);
  },

  /**
   * Cập nhật quyền hạn realtime (gọi từ WebSocket)
   * Giống MIMOSA: moduleContextActions.updatePermission
   * @param {Guid} userId - ID của user cần cập nhật permission
   */
  async updatePermission(userId) {
    try {
      // Gọi API lấy permission mới từ server
      const newPermission = await accountApi.getPermission(userId);
      
      // Cập nhật vào state (Pinia reactive)
      if (newPermission) {
        this.permission = newPermission;
        
        // Force update localStorage (do Pinia persist có thể chưa kịp sync)
        const contextData = localStorage.getItem('context');
        if (contextData) {
          try {
            const parsedContext = JSON.parse(contextData);
            parsedContext.permission = newPermission;
            localStorage.setItem('context', JSON.stringify(parsedContext));
            console.log('✅ Permission updated in localStorage:', newPermission);
          } catch (ex) {
            console.error('Error updating localStorage:', ex);
          }
        }
      }
      
      return newPermission;
    } catch (error) {
      console.error('Error updating permission:', error);
      return null;
    }
  },

  /**
   * @description Sự kiện đóng cảnh báo hết hạn license
   * @param {*} payload
   * nvxuan 21.09.2023
   */
  async closeWarningDate(payload) {
    // Lưu xuống DB
    await accountApi.closeWarningDate(payload);

    // Update lại context
    // popupType 1 Top | 2 Center | 3 Bottom-Right
    if (payload?.WarningPopupType == 1 && this.context?.Context?.WarningExpied?.ShowWarningExpiredDateTop == true) {
      this.context.Context.WarningExpied.ShowWarningExpiredDateTop = false;
    } else if (payload?.WarningPopupType == 3 && this.context?.Context?.WarningExpied?.ShowWarningExpiredDate == true) {
      this.context.Context.WarningExpied.ShowWarningExpiredDate = false;
    }
  },

  /**
   * Kiểm tra xem database với database_id có đang sao lưu dữ liệu hay không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện sao lưu không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện khôi phục dữ liệu không
   * nvxuan 20.11.2023
   */
  async checkBusyBackupRestore(dbId, userId) {
    return await accountApi.checkBusyBackupRestore(dbId, userId);
  },

  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   * @param {*} payload {serveyCustomID, userId, state}
   * @returns
   * nvxuan 02.02.2024
   */
  async recordNpsServey(payload) {
    return await accountApi.recordNpsServey(payload);
  },
  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   * @param {*} payload {serveyCustomID, userId, state}
   * @returns
   * nvxuan 02.02.2024
   */
  async recordNpsServeyProactive(payload) {
    return await accountApi.recordNpsServeyProactive(payload);
  },
};
const getters = {
  PostedDate() {
    return this.context.PostedDate;
  },

  CurUserId() {
    return this.context?.Context?.UserId;
  },

  CurDatabaseId() {
    return this.context?.Context?.DatabaseId;
  },
  CurDatabaseName() {
    return this.context?.Context?.DatabaseName;
  },
  CurAccountingDate() {
    return this.context?.Context?.AccountingDate;
  },

  CurTenantId() {
    return this.context?.Context?.TenantId;
  },
  CurSessionId() {
    return this.context?.Context?.SessionId;
  },
  Permission() {
    return this.permission;
  },
  Context() {
    return this.context?.Context;
  },
  User() {
    return this.context?.user;
  },
  Token() {
    return this.context?.Token;
  },
  IsAdmin() {
    return this.context?.Context?.IsAdmin||false;
  },
  /** Danh sách role_code của user đang đăng nhập (từ login response Context.RoleCodes) */
  UserRoleCodes() {
    return this.context?.Context?.RoleCodes || [];
  },
  /** Kiểm tra user có thuộc 1 trong các role_code truyền vào không (getter trả closure để nhận tham số) */
  hasRole() {
    return roleCodes => {
      const userCodes = this.UserRoleCodes;
      if (!Array.isArray(userCodes) || !Array.isArray(roleCodes)) return false;
      return userCodes.some(code => roleCodes.includes(code));
    };
  },
};

export const useContextStore = defineStore(ModuleContext, {
  state: () => state,
  actions,
  getters: getters,
  persist: {
    storage: localStorage,
    beforeRestore: (ctx, action) => {},
    afterRestore: (ctx, action) => {},
    debug: true,
  },
});
